import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form } from 'antd';
import { normalizeTranslations } from '../../components/LocalizedContentTabs';
import { PetSkinFormFields, PET_SKIN_LANG_FIELDS } from './fields';

export const PetSkinCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'pet-skins' });

  return (
    <Create resource="pet-skins" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          priceCoins: 200,
          sortOrder: 0,
          isActive: true,
          poseImageUrls: [],
          moodAnimationUrls: [],
          moodImageUrls: [],
          isComingSoon: false,
          isNew: false,
          isFeatured: false,
        }}
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, PET_SKIN_LANG_FIELDS),
          })
        }
      >
        <PetSkinFormFields slugEditable />
      </Form>
    </Create>
  );
};
